import React from 'react';

import { Flex } from '@chakra-ui/react';

import { Plus } from 'assets/assetsV1/iconComponents';
import { MeshMavenWithThumbsUp } from 'assets/assetsV1/iconComponents/MeshMavenWithThumbsUp';

import { isMobileView } from 'constants/isMobileView';

import { Button } from 'uiToolkitV1/Button';
import { Divider } from 'uiToolkitV1/Divider';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const MlSuggestions = ({
  title,
  subTitle,
  handleAdd,
  isNudgeCard = false,
}: {
  title: string;
  subTitle: string;
  handleAdd: () => void;
  isNudgeCard?: boolean;
}) => {
  const mobileViewButtonProps = isMobileView()
    ? { paddingLeft: '0px!important', marginLeft: '0px', width: 'fit-content' }
    : {};

  return (
    <>
      <Flex p="12px 28px 12px 44px" flexDirection={isMobileView() ? 'column' : 'row'}>
        <Flex flexDirection="column">
          <TextBodyMedium mb="8px">{title}</TextBodyMedium>
          <Flex alignItems="center">
            <TextLabel color="text.g2">{isNudgeCard ? 'Suggested' : 'Identified'} by</TextLabel>

            <MeshMavenWithThumbsUp boxSize="16px" mr="4px" ml="4px" />

            <TextLabel color="text.g2">Maven</TextLabel>
          </Flex>
        </Flex>
        <Button
          sx={{
            marginLeft: 'auto',
            ...mobileViewButtonProps,
          }}
          StartIcon={Plus}
          onClick={handleAdd}
          variant="tertiary"
        >
          Add to {subTitle}
        </Button>
      </Flex>
      <Divider m="0px 10px" opacity={1} color="#CFD7DF" />
    </>
  );
};

export default MlSuggestions;
